import { AppAnalyticsState } from "@/pages/AppAnalytics/AppAnalytics";

export type JobStatus = 'Pending' | 'InProgress' | 'Completed' | 'Failed';

export class ExportAnalyticsJob {
  params: AppAnalyticsState = null;
  isPopupOpen: boolean = true;
  jobType: string = null;
  jobStatus: JobStatus = 'Pending';
  message: string = '';
  progress: number = 0;

  intervalId: number | null = null;

  constructor(
    jobType: string,
    params: AppAnalyticsState
  ) {
    this.jobType = jobType;
    this.params = params;
  }
}
